import Button from './inputs/Button';
import TextInput from './inputs/TextInput';
import RadioInput from './inputs/RadioInput';
import CheckboxInput from './inputs/CheckboxInput';
import SelectInput from './inputs/SelectInput';
import Accordion from './Accordion';
import CreditCard from './CreditCard';
import Toggle from './Toggle';

import { FaRegArrowAltCircleRight, FaEyeSlash, FaSearch } from 'react-icons/fa';
import AddPaymentMethod from './payments/AddPaymentMethod';

export default function AllComponents() {
  return (
    <div className="flex flex-col items-center mx-auto space-y-8 pt-12 h-screen w-screen overflow-auto">
      <AddPaymentMethod className={undefined} urlParamsToPersist={undefined} />
      <Toggle options={['left', 'right']} />
      <CreditCard />
      <h1>H1 Heading</h1>
      <h2>H2 Heading</h2>
      <h3>H3 Heading</h3>
      <h4>H4 Heading</h4>
      <p>normal</p>
      <p className="text-sm">small</p>
      <p className="font-bold">bold</p>
      <p className="text-sm font-bold">small bold</p>
      <p className="font-extrabold">button text normal</p>
      <p className="text-sm font-extrabold">button text small</p>
      <p className="font-semibold text-lg">caption</p>
      <p className="font-semibold">caption small</p>
      <p className="font-light text-3xl">caption large</p>
      <p className="font-bold text-xs">caption extra small</p>
      <p className="text-lg font-extrabold">table col</p>
      <p className="text-lg">table text</p>
      <TextInput type="text" value="example" />
      with value
      <TextInput type="text" placeholder="placeholder" />
      empty
      <TextInput type="text" validated />
      validated
      <TextInput type="text" error />
      error
      <TextInput type="text" disabled placeholder="disabled" />
      disabled
      <TextInput type="password" iconRight={<FaEyeSlash />} />
      <TextInput type="search" iconLeft={<FaSearch />} />
      <TextInput type="text" iconRight={<FaRegArrowAltCircleRight />} />
      <SelectInput placeholder="Something:" />
      <RadioInput checked={false} />
      <RadioInput checked={true} />
      <CheckboxInput checked={false} />
      <CheckboxInput checked={true} />
      <Button primary>Primary</Button>
      <Button secondary>Secondary</Button>
      <Button>Sign Up</Button>
      <Button disabled>Disabled</Button>
      <Button primary disabled>
        Primary Disabled
      </Button>
      <Button secondary disabled>
        Secondary Disabled
      </Button>
      <Accordion label="Accordion Label">
        <div className="bg-amber-600 h-96">Accordion body</div>
      </Accordion>
      <Accordion label="Accordion Label" openInitial={true}>
        <div className="bg-amber-600">Accordion body</div>
      </Accordion>
    </div>
  );
}
